import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePageSpeedSettings } from "../openapi/api-client.ts";
import { components } from "../openapi/generated-types.ts";

export const useUpdatePageSpeedSettings = (
  projectId: string,
  appInstallationId: string,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: components["schemas"]["PageSpeedSettings"]) => {
      return updatePageSpeedSettings(settings, {
        path: { projectId, appInstallationId },
      });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["pageSpeedSettings", { projectId, appInstallationId }],
      });
    },
  });
};
